<template>
  <!-- Diálogo de Carregamento -->
  <v-dialog v-model="loading" max-width="400" persistent>
    <v-card elevation="12" class="text-center" color="white" style="border-radius: 16px;">
      <v-card-text class="pa-8">
        <v-progress-circular indeterminate color="primary" size="48" class="mb-6"></v-progress-circular>
        <div class="loading-title font-weight-bold text-h6 mb-4" style="color: #3f51b5;">
          Carregando Simulados...
        </div>
        <div class="loading-text text-body-2" style="color: #666; line-height: 1.6;">
          <p class="mb-2">As questões que você já realizou estão sendo contabilizadas, aguarde.</p>
          <p style="color: #999; font-size: 12px;">Se estiver demorando muito, <strong>tente atualizar a página ou aperte (F5).</strong></p>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Diálogo de Informações do Simulado -->
  <v-dialog v-model="showQuestionResetDialog" max-width="650">
    <v-card class="pa-6 elevation-4" style="background: #f5f5f5; border-radius: 15px;">
      <v-card-title class="headline text-center" style="color: #3f51b5;">
        <v-icon left>mdi-information-outline</v-icon>
        <strong>Simulado</strong>
      </v-card-title>
      <v-card-text>
        <p class="text-body-1" style="font-size: 16px; color: #333;">
          <strong>Sobre o Simulado.</strong>
        </p>
        <v-divider></v-divider>
        <v-list dense>
          <v-list-item v-for="(item, index) in [
            'Tempo máximo: Simulado 4 horas / Teórico-prático 1 hora.',
            'Não será possível repetir questões.',
            'Não será possível repetir o simulado feito.',
            'O Gabarito será disponibilizado posteriormente, na aba Gabarito Simulados'
          ]" :key="index">
            <v-list-item-icon>
              <v-icon>mdi-checkbox-marked-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-body-2" style="word-wrap: break-word; white-space: normal;">
                {{ item }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="closeSuggestionDialog" color="primary" rounded>Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Diálogo de Salvamento -->
  <v-dialog v-model="resetting" max-width="400" persistent>
    <v-card>
      <v-card-title>Salvando dados.</v-card-title>
      <v-card-text>
        Aguarde enquanto seus dados estão sendo salvos...
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Modal com o PDF de orientações -->
  <v-dialog v-model="showPdfDialog" max-width="1500" content-class="pdf-dialog" persistent>
    <v-card class="rounded-xl overflow-hidden" elevation="0" style="background: #f8fbff;">
      <v-card-title class="px-5 py-4" style="background: #ffffff; border-bottom: 1px solid rgba(63, 81, 181, 0.1);">
        <div class="d-flex justify-space-between align-start">
          <div>
            <div class="text-subtitle-1 font-weight-bold" style="color: #23304f;">Orientações e Cronograma</div>
            <div class="text-caption" style="color: #64748b;">Cronogorama de Simulados</div>
            <v-btn color="primary" variant="text" class="text-none px-0 mt-2" style="font-size: 0.8rem; min-height: auto;" @click="openPdfInNewTab">
              Abrir em outra aba
            </v-btn>
          </div>
          <v-btn icon variant="text" @click="closePdfDialog" aria-label="Fechar PDF">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text class="pa-0" style="background: #f8fbff;">
        <iframe
          :src="pdfUrl"
          title="Orientações e Cronograma"
          style="width: 100%; height: 78vh; min-height: 520px; border: 0; display: block;"
        ></iframe>
      </v-card-text>
    </v-card>
  </v-dialog>

  <!-- Modal com os Resultados -->
  <v-dialog v-model="showResultsDialog" max-width="1400" width="90%" transition="dialog-bottom-transition">
    <v-card class="rounded-xl overflow-hidden" elevation="4" style="background: #f4f6f8; max-height: 90vh; display: flex; flex-direction: column;">
      <v-toolbar color="white" elevation="1" style="flex: 0 0 auto;">
        <v-btn icon @click="closeResultsDialog" aria-label="Fechar Resultados">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title class="font-weight-bold" style="color: #23304f;">Meus Resultados - Simulados</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text class="pa-4 pa-md-6" style="background: #f4f6f8; overflow-y: auto; flex: 1 1 auto;">
        <!-- O componente SimuladosResults será renderizado aqui -->
        <SimuladosResults v-if="showResultsDialog" />
      </v-card-text>
    </v-card>
  </v-dialog>

  <div :style="$vuetify.theme.dark ? 'background-color: #030a1a; min-height: 100vh;' : 'background-color: #05122e; min-height: 100vh;'" class="d-flex flex-column align-center justify-center w-100 pa-4 position-relative">
    <v-container v-if="quizstart !== true" class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="8" lg="6" xl="4">
          <v-card class="px-auto px-6 py-8 rounded-xl elevation-12 vs-card-light" style="background-color: white;">
            
            <!-- Logo Veri Salvatori -->
            <div class="text-center mb-6">
              <div class="d-flex justify-center align-center">
                <img
                  src="/veriSalvatori/logo_site_dark.svg"
                  alt="Veri Salvatori"
                  style="max-width: 240px; height: 32px; width: auto; object-fit: contain;"
                />
              </div>
              <div style="font-family: 'Inter', sans-serif; font-size: 10px; font-weight: 600; letter-spacing: 0.32em; color: #647089; margin-top: 6px; text-transform: uppercase;">
                INSTITUTO MÉDICO
              </div>
            </div>

            <!-- Orientações (TEMFC) -->
            <div
              v-if="displayDbName === 'TEMFC'"
              class="mb-6 pa-4 rounded-lg"
              style="border: 1px solid rgba(63, 81, 181, 0.14); background: linear-gradient(135deg, #f8fbff 0%, #eef4ff 100%);"
            >
              <div class="d-flex flex-column flex-sm-row align-center justify-space-between gap-3" style="min-height: 56px;">
                <div class="d-flex align-center" style="padding-top: 2px;">
                  <div class="d-flex align-center justify-center rounded-circle mr-3" style="width: 42px; height: 42px; background: rgba(63, 81, 181, 0.12);">
                    <v-icon color="primary">mdi-calendar-check-outline</v-icon>
                  </div>
                  <div>
                    <div class="font-weight-bold text-body-1" style="color: #23304f;">Orientações e Cronograma</div>
                    <div class="text-caption" style="color: #64748b;">Confira o material oficial.</div>
                  </div>
                </div>
                <div class="d-flex align-center justify-end flex-grow-1" style="min-height: 34px; padding-right: 8px; margin-top: -2px;">
                  <v-btn
                    color="primary"
                    variant="text"
                    class="px-0 text-none"
                    style="text-decoration: underline;"
                    @click="openPdfDialog"
                  >
                    Visualizar
                  </v-btn>
                </div>
              </div>
            </div>

            <!-- Meus Resultados -->
            <div
              class="mb-6 pa-4 rounded-lg"
              style="border: 1px solid rgba(156, 39, 176, 0.14); background: linear-gradient(135deg, #fdf6ff 0%, #f6e8fa 100%); cursor: pointer; transition: all 0.3s ease;"
              @click="openResultsDialog"
              onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 12px rgba(156,39,176,0.15)'"
              onmouseout="this.style.transform='none'; this.style.boxShadow='none'"
            >
              <div class="d-flex flex-column flex-sm-row align-center justify-space-between gap-3" style="min-height: 56px;">
                <div class="d-flex align-center" style="padding-top: 2px;">
                  <div class="d-flex align-center justify-center rounded-circle mr-3" style="width: 42px; height: 42px; background: rgba(156, 39, 176, 0.12);">
                    <v-icon color="purple">mdi-poll</v-icon>
                  </div>
                  <div>
                    <div class="font-weight-bold text-body-1" style="color: #3f1d4f;">Meus Resultados</div>
                    <div class="text-caption" style="color: #64748b;">Acompanhe seu desempenho detalhado.</div>
                  </div>
                </div>
                <div class="d-flex align-center justify-end flex-grow-1" style="min-height: 34px; padding-right: 8px; margin-top: -2px;">
                  <v-btn
                    color="purple"
                    variant="text"
                    class="px-0 text-none font-weight-bold"
                    style="text-decoration: underline;"
                    @click.stop="openResultsDialog"
                  >
                    Visualizar
                  </v-btn>
                </div>
              </div>
            </div>

            <!-- Simulado Normal -->
            <div class="mb-4">
              <v-card-title class="headline text-center font-weight-bold pt-0 mb-0" style="color: #282828; white-space: normal; word-break: break-word; overflow-wrap: break-word;">
                Simulados {{ displayDbName }}
              </v-card-title>
              
              <v-card-text v-if="!hasSimulados && !onlyWrongQuestions" class="text-center pt-5 pb-0 text-body-1" style="color: #666;">
                Em breve um Simulado será disponibilizado.
              </v-card-text>
              <v-card-text v-if="selectedMode === 'Tutor'" class="px-6 pt-0 mt-2 mx-auto text-center" style="color: #555;">
                Para iniciar escolha um dos simulados disponíveis.
              </v-card-text>
              <v-select
                v-model="selectedTheme"
                :items="availableThemes"
                label="Escolha o Simulado"
                class="px-2 pt-3 mx-auto"
                placeholder="Escolha o Simulado."
                chips
                deletable-chips
                @change="handleThemeSelectionChange"
              ></v-select>
              <!-- <v-checkbox
                v-model="onlyWrongQuestions"
                class="px-2 pt-0 mx-auto"
                label="Realizar apenas questões que errei"
              ></v-checkbox> -->
              <v-card-text v-if="onlyWrongQuestions === true" class="px-2 pt-0 mt-0 mx-auto text-justify" style="color: #666; font-size: 14px;">
                Refaça apenas as questões que você não acertou nos simulados anteriores. A revisão não é considerada nas métricas.
              </v-card-text>
              <v-card-actions class="d-flex justify-center pb-5" elevation="0">
                <v-btn
                  :disabled="!selectedTheme || selectedTheme === '' || (Array.isArray(selectedTheme) && selectedTheme[0] === '')"
                  class="vs-btn-primary"
                  variant="elevated"
                  style="width: 220px; height: 52px; font-size: 16px; font-weight: 600; color: white !important; border-radius: 12px; text-transform: none; letter-spacing: 0.5px;"
                  @click="startQuiz"
                  color="primary"
                  elevation="6"
                >
                  Iniciar Simulado
                </v-btn>
              </v-card-actions>
            </div>

            <!-- Simulado Teórico-Prático -->
            <!--
            <div v-if="String(dbName) !== 'AGSUS' && displayDbName !== 'TECM'" class="mt-6 pt-4" style="border-top: 1px solid #eee;">
              <v-card-title class="headline text-center font-weight-bold pt-0 mb-0" style="color: #282828; white-space: normal; word-break: break-word; overflow-wrap: break-word;">
                Simulado Teórico-Prático {{ displayDbName }}
              </v-card-title>

              <v-card-text v-if="!hasSimulados2 && !onlyWrongQuestions2" class="text-center pt-5 pb-0 text-body-1" style="color: #666;">
                Em breve um Simulado será disponibilizado.
              </v-card-text>
              <v-card-text v-if="selectedMode === 'Tutor'" class="px-6 pt-0 mt-2 mx-auto text-center" style="color: #555;">
                Para iniciar escolha um dos simulados disponíveis.
              </v-card-text>
              <v-select
                v-model="selectedTheme2"
                :items="availableThemes2"
                label="Escolha o Simulado"
                class="px-2 pt-3 mx-auto"
                placeholder="Escolha o Simulado."
                chips
                deletable-chips
                @change="handleThemeSelectionChange2"
              ></v-select>

              <v-checkbox
                v-model="onlyWrongQuestions2"
                class="px-2 pt-0 mx-auto"
                label="Realizar apenas questões que errei"
              ></v-checkbox>
              <v-card-text v-if="onlyWrongQuestions2 === true" class="px-2 pt-0 mt-0 mx-auto text-justify" style="color: #666; font-size: 14px;">
                Refaça apenas as questões que você não acertou nos simulados anteriores. A revisão não é considerada nas métricas.
              </v-card-text>

              <v-card-actions class="d-flex justify-center pb-0" elevation="0">
                <v-btn
                  :disabled="!selectedTheme2 || selectedTheme2 === '' || (Array.isArray(selectedTheme2) && selectedTheme2[0] === '')"
                  style="width: 220px; height: 52px; font-size: 16px; font-weight: 600; color: white; border-radius: 12px; text-transform: none; letter-spacing: 0.5px;"
                  @click="startQuiz2"
                  color="#3474be"
                  variant="elevated"
                  elevation="6"
                >
                  Iniciar Simulado
                </v-btn>
              </v-card-actions>
            </div>
            -->

          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { onBeforeMount, computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import SimuladosResults from './SimuladosResults.vue';

export default {
  name: 'QuizSetup',
  components: {
    SimuladosResults
  },
  props: {
    noqdName: Number, // Número total de questões feitas
    noqName: Number, // Número total de questões disponíveis
    loadThemes: Array,
  },
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();

    // Define o admin padrão para esta página usando a mutation do Vuex para garantir reatividade global
    store.commit('setAdmin', 'tecmexp');

    // Variáveis reativas
    const onlyWrongQuestions = ref(false);
    // const onlyWrongQuestions2 = ref(false);  // ADICIONE ISTO
    const localLoadingWrong = ref(false); // Loading específico para simulados errados
    const showChallengeDialog = ref(false);
    const quizstart = ref(false);
    const selectedNumberOfQuestions = ref(1);
    const selectedTheme = ref(['']);
    // const selectedTheme2 = ref(['']);
    const selectedMode = ref('Normal');
    const showQuestionResetDialog = ref(false);
    const showPdfDialog = ref(false);
    const showResultsDialog = ref(false);
    const resetting = ref(false);
    const localLoading = ref(true); // Inicia com true para mostrar loading
    const pdfUrl = 'https://firebasestorage.googleapis.com/v0/b/medexpertsqbank-60536.appspot.com/o/PDFs%2FCronograma_Simulados_MedExperts_TEMFC.pdf?alt=media&token=0186a1b6-ff62-4fb0-b8ab-9e0d8321ac0f';

    // Computed properties
    const admin = computed(() => store.getters.admin);
    const loading = computed(() => store.getters.loading || localLoading.value || localLoadingWrong.value);
    const dbName = computed(() => store.getters.dbName);
    const displayDbName = computed(() => {
      if (store.state.admin === 'temfcadmin' || store.state.admin === 'temfc') {
        return 'TEMFC';
      } else if (store.state.admin === 'agsusadmin' || store.state.admin === 'agsus') {
        return 'AGSUS';
      } else if (store.state.admin === 'tecmadmin' || store.state.admin === 'tecm'|| store.state.admin === 'tecmexp') {
        return 'TECM';
      } else {
        return '';
      }
    });
    const completedQuestionsCount = computed(() => store.getters.noqdName);
    const availableQuestionsCount = computed(() => store.getters.noqName);

    const hasSimulados = computed(() => {
      const items = store.getters.loadedSimulados;
      return items && items.length > 0;
    });

    // const hasSimulados2 = computed(() => {
    //   const items = store.getters.loadedSimulados2;
    //   return items && items.length > 0;
    // });

    const availableThemes = computed(() => {
      const themes = new Set(['']);
      const items = onlyWrongQuestions.value 
        ? store.getters.loadedSimuladosWrong 
        : store.getters.loadedSimulados;

      items.forEach((question) => {
        if (question.simuladoNome !== '') {
          themes.add(question.simuladoNome);
        }
      });

      return Array.from(themes);
    });

  //   const availableThemes2 = computed(() => {
  //   const themes = new Set(['']);
  //   const items = onlyWrongQuestions2.value 
  //     ? store.getters.loadedSimuladosPraticoWrong 
  //     : store.getters.loadedSimulados2;

  //   items.forEach((question) => {
  //     if (question.simuladoNome !== '') {
  //       themes.add(question.simuladoNome);
  //     }
  //   });

  //   return Array.from(themes);
  // });

    // Watchers
    watch(dbName, (newDbName) => {
      if (newDbName && String(newDbName) === 'TEMFC') {
        showChallengeDialog.value = true;
      }
    });

    watch(onlyWrongQuestions, async (newVal) => {
  if (newVal) {
    selectedMode.value = 'Tutor'; // força modo Tutor quando a checkbox está marcada
        selectedTheme.value = [''];             // limpa a seleção atual do dropdown

    localLoadingWrong.value = true;
    try {
      await store.dispatch('loadSimuladosWrong');
    } catch (error) {
      console.error('Erro ao carregar simulados errados:', error);
    } finally {
      localLoadingWrong.value = false;
    }
  }
});

    // watch(onlyWrongQuestions2, async (newVal) => {
    //   if (newVal) {
    //     selectedMode.value = 'Tutor';
    //     selectedTheme2.value = [''];
    //     
    //     localLoadingWrong.value = true;
    //     try {
    //       if (store.state.admin !== 'tecmadmin' && store.state.admin !== 'tecm') {
    //         await store.dispatch('loadSimuladosPraticoWrong');
    //       }
    //     } catch (error) {
    //       console.error('Erro ao carregar simulados práticos errados:', error);
    //     } finally {
    //       localLoadingWrong.value = false;
    //     }
    //   }
    // });

    const loadSimuladosData = async () => {
      const adminValue = store.getters.admin;
      if (typeof adminValue === 'string' && (adminValue.trim() === '' || adminValue.includes(','))) {
        localLoading.value = false;
        return;
      }

      localLoading.value = true;
      try {
        const actionsToLoad = [store.dispatch('loadSimulados')];
        if (adminValue !== 'tecmadmin' && adminValue !== 'tecm') {
          // actionsToLoad.push(store.dispatch('loadSimulados2'));
        }

        await Promise.all(actionsToLoad);

        if (String(dbName.value) === 'TEMFC') {
          showChallengeDialog.value = true;
        }
      } catch (error) {
        console.error('Erro ao carregar simulados:', error);
      } finally {
        localLoading.value = false;
      }
    };

    watch(admin, (newAdmin) => {
      if (typeof newAdmin === 'string' && newAdmin.trim() !== '' && !newAdmin.includes(',')) {
        loadSimuladosData();
      }
    });

    // Lifecycle Hooks
    onBeforeMount(() => {
      localStorage.clear();
      document.cookie = '';
      loadSimuladosData();
    });

    // Métodos
    const openQuestionResetDialog = () => {
      showQuestionResetDialog.value = true;
    };

    const closeSuggestionDialog = () => {
      showQuestionResetDialog.value = false;
    };

    const openPdfDialog = () => {
      showPdfDialog.value = true;
    };

    const closePdfDialog = () => {
      showPdfDialog.value = false;
    };

    const openPdfInNewTab = () => {
      window.open(pdfUrl, '_blank', 'noopener,noreferrer');
    };

    const openResultsDialog = () => {
      showResultsDialog.value = true;
    };

    const closeResultsDialog = () => {
      showResultsDialog.value = false;
    };

    const saveQuestionReset = () => {
      resetting.value = true;
      store.dispatch('saveQuestionReset')
        .then(() => {
          setTimeout(() => {
            store.dispatch('loadItems');
          }, 1000);
          setTimeout(() => {
            resetting.value = false;
          }, 5000);
        })
        .catch((error) => {
          console.error('Erro ao salvar item:', error);
        });
      closeSuggestionDialog();
    };

    const handleThemeSelectionChange = (newVal) => {
      selectedTheme.value = newVal;

      if (selectedTheme.value.includes('Todos') && selectedTheme.value.length > 1) {
        const todosIndex = selectedTheme.value.indexOf('Todos');
        selectedTheme.value.splice(todosIndex, 1);
      } else if (selectedTheme.value.length === 0) {
        selectedTheme.value = ['Todos'];
      }

      console.log('Tema selecionado:', selectedTheme.value);
    };

    // const handleThemeSelectionChange2 = (newVal) => {
    //   selectedTheme2.value = newVal;

    //   if (selectedTheme2.value.includes('Todos') && selectedTheme2.value.length > 1) {
    //     const todosIndex = selectedTheme2.value.indexOf('Todos');
    //     selectedTheme2.value.splice(todosIndex, 1);
    //   } else if (selectedTheme2.value.length === 0) {
    //     selectedTheme2.value = ['Todos'];
    //   }

    //   console.log('Tema selecionado 2:', selectedTheme2.value);
    // };

    const startQuiz = async () => {
      let filteredItems = [];
      const sourceItems = onlyWrongQuestions.value 
        ? store.getters.loadedSimuladosWrong 
        : store.getters.loadedSimulados;

      sourceItems.forEach((item) => {
        if (selectedTheme.value.includes('Todos')) {
          filteredItems.push(item);
        } else if (selectedTheme.value.includes(item.simuladoNome)) {
          filteredItems.push(item);
        }
      });

      emit('start-quiz', {
        items: filteredItems,
        mode: selectedMode.value,
      });

      router.push({
        name: 'TECMQuestionQuizSimuladoLanding',
        query: {
          mode: selectedMode.value,
          items: JSON.stringify(filteredItems),
          isReview: onlyWrongQuestions.value  // <<< adiciona a flag aqui

        },
      });
    };

    // const startQuiz2 = async () => {
    //   let filteredItems2 = [];
    //   const sourceItems2 = onlyWrongQuestions2.value 
    //     ? store.getters.loadedSimuladosPraticoWrong 
    //     : store.getters.loadedSimulados2;

    //   sourceItems2.forEach((item) => {
    //     if (selectedTheme2.value.includes('Todos')) {
    //       filteredItems2.push(item);
    //     } else if (selectedTheme2.value.includes(item.simuladoNome)) {
    //       filteredItems2.push(item);
    //     }
    //   });

    //   emit('start-quiz', {
    //     items: filteredItems2,
    //     mode: selectedMode.value,
    //   });

    //   router.push({
    //     name: 'QuestionsQuizSimuladoPratico',
    //     query: {
    //       mode: selectedMode.value,
    //       items: JSON.stringify(filteredItems2),
    //       isReview: onlyWrongQuestions2.value  // ADICIONE ISTO
    //     },
    //   });
    // };

    return {
      quizstart,
      showChallengeDialog,
      showQuestionResetDialog,
      showResultsDialog,
      selectedNumberOfQuestions,
      selectedTheme,
      // selectedTheme2,
      selectedMode,
      resetting,
      dbName,
      displayDbName,
      completedQuestionsCount,
      availableQuestionsCount,
      localLoading,
      openQuestionResetDialog,
      closeSuggestionDialog,
      openPdfDialog,
      closePdfDialog,
      openPdfInNewTab,
      openResultsDialog,
      closeResultsDialog,
      saveQuestionReset,
      handleThemeSelectionChange,
      // handleThemeSelectionChange2,
      startQuiz,
      // startQuiz2,
      availableThemes,
      // availableThemes2,
      loading,
      showPdfDialog,
      pdfUrl,
      onlyWrongQuestions,
      // onlyWrongQuestions2,
      hasSimulados,
      // hasSimulados2,
    };
  },
};
</script>

<style scoped>
/* Estilos opcionais */
</style>